import React from 'react';
import PropTypes from 'prop-types';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { ContentContainer } from 'web-ui-components/lib/layout/containers';
import { ApplicationFormShell } from 'web-ui-components/lib/layout/shells';
import { VerticalMenu } from 'web-ui-components/lib/navigation/menus';
import moment from 'moment';
import AnalyticsUtil from '../../../utils/AnalyticsUtil';
import config from '../../../config';
import {
  PAGE_CALL_PAYMENT,
  PAGE_CONTACT_DETAILS,
  PAGE_DISPUTE_PAYMENT,
  PAGE_HELP_WITH_PAYMENT,
  PAGE_PENDING_PAYMENT,
  PAGE_MINIMUM_DISPUTE_THRESHOLD,
  MINIMUM_DISPUTE_THRESHOLD_DAYS,
} from '../../../constants/FraudAndDisputeConstants';

export const DisputePayment = (props) => {
  const { content, setPage, closeDisputePaymentModal, data } = props;
  const paymentDate = moment(data.dateRaw, config.dateFormatInAPI);
  const dateDiff = moment().diff(paymentDate, 'day');
  const verticalMenuItems = [
    {
      heading: content.disputePaymentOption1,
      id: 'goods-not-received',
      onClick: () => {
        AnalyticsUtil.analyticAction(
          config.analytics.analytics_experience_activity,
          config.analytics.analytics_event_method_interacted,
          config.analytics.analytics_action_dispute_payment_no_goods,
          config.analytics.analytics_action_button_click
        );
        if (!data.posted) {
          setPage(PAGE_PENDING_PAYMENT);
        } else if (dateDiff < MINIMUM_DISPUTE_THRESHOLD_DAYS) {
          setPage(PAGE_MINIMUM_DISPUTE_THRESHOLD);
        } else {
          setPage(PAGE_CONTACT_DETAILS);
        }
      },
    },
    {
      heading: content.disputePaymentOption2,
      id: 'damaged-item',
      onClick: () => {
        AnalyticsUtil.analyticAction(
          config.analytics.analytics_experience_activity,
          config.analytics.analytics_event_method_interacted,
          config.analytics.analytics_action_dispute_payment_damaged_item,
          config.analytics.analytics_action_button_click
        );
        setPage(PAGE_CALL_PAYMENT, PAGE_DISPUTE_PAYMENT);
      },
    },
    {
      heading: content.disputePaymentOption3,
      id: 'over-charged',
      onClick: () => {
        AnalyticsUtil.analyticAction(
          config.analytics.analytics_experience_activity,
          config.analytics.analytics_event_method_interacted,
          config.analytics.analytics_action_dispute_payment_over_charged,
          config.analytics.analytics_action_button_click
        );
        setPage(PAGE_CALL_PAYMENT, PAGE_DISPUTE_PAYMENT);
      },
    },
    {
      heading: content.disputePaymentOption4,
      id: 'no-refund',
      onClick: () => {
        AnalyticsUtil.analyticAction(
          config.analytics.analytics_experience_activity,
          config.analytics.analytics_event_method_interacted,
          config.analytics.analytics_action_dispute_payment_no_refund,
          config.analytics.analytics_action_button_click
        );
        setPage(PAGE_CALL_PAYMENT, PAGE_DISPUTE_PAYMENT);
      },
    },
    {
      heading: content.disputePaymentOption5,
      id: 'something-else',
      onClick: () => {
        AnalyticsUtil.analyticAction(
          config.analytics.analytics_experience_activity,
          config.analytics.analytics_event_method_interacted,
          config.analytics.analytics_action_dispute_payment_something_else,
          config.analytics.analytics_action_button_click
        );
        setPage(PAGE_CALL_PAYMENT, PAGE_DISPUTE_PAYMENT);
      },
    },
  ];
  return (
    <ApplicationFormShell>
      <ContentContainer>
        <PageHeading>{content.disputePaymentTitle}</PageHeading>
        <VerticalMenu items={verticalMenuItems} />
      </ContentContainer>
      <ContentContainer>
        <div className="dispute-nav-buttons">
          <NavigationButton.Secondary
            data-test-id="cancel-button"
            labelText={content.cancelText}
            onClick={() => {
              setPage(PAGE_HELP_WITH_PAYMENT);
              closeDisputePaymentModal();
            }}
          />
        </div>
      </ContentContainer>
    </ApplicationFormShell>
  );
};

DisputePayment.propTypes = {
  content: PropTypes.object,
  setPage: PropTypes.func,
  closeDisputePaymentModal: PropTypes.func,
};
